module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"my_profile":"Meu perfil","my_profile_description":"Configurações da conta","billing":"Cobrança","billing_description":"Cobranças e notas","sign_out":"Sair","hi":"Olá"},"en-US":{"my_profile":"My profile","my_profile_description":"Account settings","billing":"Billing","billing_description":"billing & statements","sign_out":"Sign Out","hi":"Hi"}}')
  delete Component.options._Ctor
}
